import i18n from "../../i18n/index";
export default {
  props: {
    totalItems: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      headers: [
        { text: i18n.t('headers.provider'), value: "providerId", sortable: false },
        {
          text: i18n.t('calculator-total-label'),
          value: "calculatorTotal",
          sortable: false
        }
      ],
      itemsData: []
    };
  },
  watch: {
    totalItems() {
      this.itemsData = this.totalItems;
    }
  }
};
